import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { PetAvatar } from './pet-avatar';
import { AvatarSizes } from './AvatarEnums';
import './pet-avatar-button.scss';

export const PetAvatarButton = ({
  click,
  alt = 'pet avatar',
  size,
  image,
  children,
  isSelected,
}: {
  click: () => void;
  alt?: string;
  size: AvatarSizes;
  image: string;
  children?: ReactNode;
  isSelected: boolean;
}) => (
  <button
    type="button"
    className={classNames('pet-avatar-button', { selected: isSelected })}
    onClick={click}
    data-testid={isSelected ? 'selected-avatar-button' : ''}
    data-selectedimage={image}
    aria-pressed={isSelected}
  >
    <PetAvatar className="pet-avatar-button__image" alt={alt} size={size} src={image} />
    {children && <span className="pet-avatar-button__text">{children}</span>}
  </button>
);
